import { AxiosError, AxiosResponse } from "axios";
import {
  ICompanyStatutoryHoliday,
  ICompanyStatutoryHolidayEligibilityPanel,
  ICompanyStatutoryHolidayListPayload,
  ICompanyStatutoryHolidayResponse,
} from "../models/companyStatutoryHoliday";
import { IGetListRequest, IResponse, IServerError } from "../models/common";

import http from "../common/http-commons";
import { IStatutoryHolidayResponse } from "../models/statutoryHoliday/IStatutoryHolidayResponse";

export const CompanyStatutoryHolidayService = {
  getStatutoryHolidayFormDataById: async (
    clientId: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<
    ICompanyStatutoryHoliday | IServerError | IResponse | null | any
  > => {
    if (!clientId) return null;
    try {
      const response: AxiosResponse<ICompanyStatutoryHoliday> =
        await http.get<ICompanyStatutoryHoliday>(`/v1/shs/${clientId}/`);

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  getStatutoryHolidayProvinceCardsListById: async (
    clientId: string | undefined,
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<
    ICompanyStatutoryHoliday | IServerError | IResponse | null | any
  > => {
    if (!clientId) return null;
    try {
      const response: AxiosResponse<ICompanyStatutoryHoliday> =
        await http.get<ICompanyStatutoryHoliday>(
          "/v1/shs-rules/?client_id=" +
            clientId +
            "&order_by=" +
            data.order_by +
            "&order_direction=" +
            data.order_direction +
            "&page=" +
            data.page +
            "&size=" +
            data.size,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  create: async (
    requestPayload: any,
  ): Promise<ICompanyStatutoryHoliday | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<ICompanyStatutoryHoliday> =
          await http.put<ICompanyStatutoryHoliday>(
            `/v1/shs/${requestPayload.clientId}/?id=${requestPayload.id}`,
            requestPayload,
          );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<ICompanyStatutoryHoliday> =
        await http.post<ICompanyStatutoryHoliday>(`/v1/shs/`, requestPayload);

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  createStatutoryHolidayProvinceCards: async (
    requestPayload: any,
  ): Promise<ICompanyStatutoryHoliday | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<ICompanyStatutoryHoliday> =
          await http.put<ICompanyStatutoryHoliday>(
            `/v1/shs-rules/${requestPayload.id}/`,
            requestPayload,
          );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<ICompanyStatutoryHolidayListPayload> =
        await http.post<ICompanyStatutoryHolidayListPayload>(
          `/v1/shs-rules/`,
          requestPayload,
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  // createStatutoryHolidayEmployeeEligibilityPanel: async (
  // 	requestPayload: any
  // ): Promise<any | IServerError | IResponse> => {

  // 	let response: AxiosResponse<any>;

  // 	if (requestPayload.billingAssociationId == undefined) {
  // 		const transformedPayload = {
  // 			billingProfileId: requestPayload.profileId,
  // 			clients: [requestPayload.clientId],
  // 		};

  // 		response = await http.post<any>(
  // 			`/v1/billing-profile-association/`,
  // 			transformedPayload
  // 		);
  // 	} else {
  // 		response = await http.put<any>(
  // 			`/v1/billing-profile-association/${requestPayload.profileId}/assign-clients/?client_id=${requestPayload.clientId}&association_flag=${requestPayload.flag}`
  // 		);
  // 	}

  // 	if (response.status === 201 || response.status === 200) {
  // 		return response.data;
  // 	} else if (response.status === 200) {
  // 		let responseWithFlag = {
  // 			client: response.data,
  // 			status: requestPayload.flag,
  // 		};
  // 		return responseWithFlag;
  // 		// return response.data;
  // 	} else if (response.status === 400) {
  // 		return {
  // 			status: false,
  // 			message: "400 Bad Request.",
  // 			error: true,
  // 		};
  // 	} else if (response.status === 500) {
  // 		return {
  // 			status: false,
  // 			message: "Something went wrong.",
  // 			error: true,
  // 		};
  // 	}

  // 	return {
  // 		status: false,
  // 		message: "Something went wrong please try again later.",
  // 	};
  // },

  createStatutoryHolidayEmployeeEligibilityPanel: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    let response: AxiosResponse<any>;
    response = await http.put<any>(
      `/v1/statutory-holiday-employee-eligibility/${requestPayload.employeeId}/?association_flag=${requestPayload.flag}`,
    );

    if (response.status === 201 || response.status === 200) {
      return {
        client: response.data,
        status: requestPayload.flag,
      };
      // return response.data;
    }
    // else if (response.status === 200) {
    // 	let responseWithFlag = {
    // 		client: response.data,
    // 		status: requestPayload.flag,
    // 	};
    // 	return responseWithFlag;
    // 	// return response.data;
    // }
    else if (response.status === 400) {
      return {
        status: false,
        message: "400 Bad Request.",
        error: true,
      };
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },

  createStatutoryHolidayBulkEmployeeEligibilityPanel: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    let response: AxiosResponse<any>;
    response = await http.put<any>(
      `/v1/statutory-holiday-employee-eligibility/update-bulk-employee-eligibility?association_flag=${requestPayload.flag}`,
      requestPayload.ids,
    );

    if (response.status === 201 || response.status === 200) {
      return {
        client: response.data,
        status: requestPayload.flag,
      };
    } else if (response.status === 400) {
      return {
        status: false,
        message: "400 Bad Request.",
        error: true,
      };
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },

  getStatutoryHolidayEemployeePanelsAssignedToScreen: async (
    clientId: string,
  ): Promise<
    ICompanyStatutoryHolidayEligibilityPanel | IServerError | IResponse | null
  > => {
    const response: AxiosResponse<ICompanyStatutoryHolidayEligibilityPanel> =
      await http.get<ICompanyStatutoryHolidayEligibilityPanel>(
        `/v1/statutory-holiday-employee-eligibility/get-eligible-ineligible-employee?client_id=${clientId}`,
      );

    if (response.status === 200) {
      return response.data;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },

  delStatutoryHoliday: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/shs-rules/${delPayload.statutoryHolidayId}/`,
      );

      if (response.status === 200) {
        return "Statutory Holidayhas been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delBulkStatutoryHoliday: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response = await http.delete<string>(
        `/v1/statutory-holiday-profile/`,
        {
          data: requestPayload.statutoryHolidayIds,
        },
      );
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  // getStatutoryHolidayDDL: async (): Promise<
  // 	any | IServerError | IResponse | null
  // > => {
  // 	const response: AxiosResponse<any[]> = await http.get<any[]>(
  // 		`/v1/statutory-holiday-profile/statutory-holiday-profile-ddl`
  // 	);

  // 	if (response.status === 200) {
  // 		return response.data;
  // 	}

  // 	return {
  // 		status: false,
  // 		message: "Something went wrong please try again later.",
  // 	};
  // },
  archiveStatutoryHoliday: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/statutory-holiday-profile-ddl/${archivePayload.statutoryHolidayId}/`,
      );

      if (response.status === 201) {
        return "statutory holiday profile has been archived successfully";
      } else if (response.status === 200) {
        return "statutory holiday profile has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  getStatutoryHolidayProfileListStatus: async (
		clientId: string,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<
		| IStatutoryHolidayResponse
		| IServerError
		| IResponse
		| null
	> => {
		try {
			const response: AxiosResponse<IStatutoryHolidayResponse> =
				await http.get<IStatutoryHolidayResponse>(
					`/v1/statutory-holiday-profile/get-list-for-clients-plus-super-user?client_id=${clientId}&tax_year=${taxYear}`,
				);
				console.log("response", response)

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getStatutoryHolidayProfileListStatusUpdate: async (
		clientId: string,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<
		| IStatutoryHolidayResponse
		| IServerError
		| IResponse
		| null
	> => {
		try {
			const response: AxiosResponse<IStatutoryHolidayResponse> =
				await http.put<IStatutoryHolidayResponse>(
					`/v1/statutory-holiday-profile/update-and-create-client-holidays?client_id=${clientId}&tax_year=${taxYear}`,
				);
				console.log("response", response)

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

  updateStatutoryHolidayProfileListStatus: async (
		requestPayload: any,
	): Promise<ICompanyStatutoryHoliday | IServerError | IResponse | any> => {
		// if (requestPayload.id) {
			try {
				const response: AxiosResponse<ICompanyStatutoryHoliday> =
					await http.put<ICompanyStatutoryHoliday>(
						`/v1/statutory-holiday-profile/update-and-create-client-holidays`,
						requestPayload,
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		// }
	},
};
